import JSEncrypt from 'jsencrypt';
const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAs1o718H4UTwKrtVNZxD2Vqx922bNv1QVzTKCESK6tk8ebOlUqkUlaPclEtUcGa7hIxW0AWP7P9WPGrZkfhmP4dO7edsoTYODxNw8MvvNFKzX+jSfkc+apJvBICTPF+mPnqMvErjEpNeA9VEFOl2SzP5cejYvyTsmQaB80o9Jf5MVexW+55Lnui+z1VQ5DtLFDXKdcQkc5BRFwsznzPKC9RnmQfVNntpZfOgPFup7dB/8Pv+2jy3n2HctCzRs8S8QBK7nijv1HnnstoNdvoyTwAlVRspHjTC3Jd9rU3k1w1jjxiFworOkTT3UejZpXsl47X8AWldN8D8+zuvx/N9PqwIDAQAB';
const encrypt = new JSEncrypt();

export const encodeByPublicKey = (str: string) => {
  encrypt.setPublicKey(publicKey);
  let encryptData = encrypt.encrypt(str);
  if (encryptData === false) {
      return '';
  }
  if (encryptData) {
      encryptData = encryptData.replace(' ', '');
  }
  return encryptData;
};